<template>
  <div id="his_system" :style="`height: ${isQiankun ? 'calc(100VH - 48px)' : '100VH'}`">
    <router-view />
  </div>
</template>

<script lang="js">
import req from '@/utils/request'
export default {
  name: 'app',
  data() {
    return {
      isQiankun: window.__POWERED_BY_QIANKUN__,
      currentVersion: process.env.VUE_APP_VERSION || '',
      hasNotified: false,
      checkInterval: 60 * 1000,
      checkClock: null
    }
  },
  created() {
    if (process.env.NODE_ENV === 'production') {
      this.versionCheckInit()
    }
  },
  beforeDestroy() {},
  methods: {
    startChecking () {
      this.checkClock = setInterval(() => {
        this.checkForUpdate()
      }, this.checkInterval)
    },
    stopChecking () {
      clearInterval(this.checkClock)
    },
    async checkForUpdate () {
      const res = await req.get(`/version.json?t=${Date.now()}`, null, '')
      if (res.code === 200) {
        const lastVersion = res.data.version
        const silence = ['', null, undefined].includes(res.data.silence) ? false : res.data.silence
        if (lastVersion !== this.currentVersion && !silence && !this.hasNotified) {
          this.hasNotified = true
          this.stopChecking()
          this.$confirm('发现新版本，请及时更新！', '提示', {
            type: 'warning',
            confirmButtonText: '立即刷新',
            showClose: false,
            showCancelButton: false,
            closeOnClickModal: false,
            closeOnPressEscape: false
          }).then(() => {
            const url = `${window.location.origin}${window.location.pathname}${window.location.search === '' ? '?version=' + lastVersion : window.location.search + '&version=' + lastVersion}`
            window.location.href = url
          }).catch(() => {})
        }
      }
    },
    versionCheckInit () {
      this.startChecking()
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible' && !this.hasNotified) {
          this.checkForUpdate()
        }
      })
    }
  }
}
</script>

<style lang="less">
.app{
  font-size: 16px;
}
@import "./assets/css/reset.less"; // 引入重置样式
@import "./assets/css/common.less"; // 引入公用样式
@import "./assets/font/iconfont.css"; // 引入主页字体图标

::-webkit-scrollbar {
  -webkit-appearance: none;
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.1);
  border-radius: 0;
}

::-webkit-scrollbar-thumb {
  cursor: pointer;
  border-radius: 5px;
  background: rgba(0, 0, 0, 0.15);
  transition: color 0.2s ease;
}

::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 0, 0, 0.3);
}

.el-message {
  top: 90px !important;
}

.el-message-box {
  width: 358px;
}
.el-tooltip__popper{
    max-width: 1000px;
}
</style>